







































































































































import Vue from 'vue';

import SimpleBar from 'simplebar';
import 'simplebar/dist/simplebar.min.css';

export default Vue.extend({
    name: 'storybook',
    data: () => {
        return {
            simplebar: null,
            simplebarScrollElement: null,
        };
    },
    props: [
        'currentView',
    ],
    computed: {
        currentFont(): string {
            return this.$store.state.currentFont;
        },
    },
    methods: {
        changeView() {
            this.$emit('changeview');
        },
        ensureInView(container: HTMLElement, element: HTMLElement) {
            // Determine container top and bottom
            const cTop = container.scrollTop;
            const cBottom = cTop + container.clientHeight;

            // Determine element top and bottom
            const eTop = element.offsetTop;
            const eBottom = eTop + element.clientHeight;

            // Check if out of view
            if (eTop < cTop) {
                container.scrollTop -= (cTop - eTop);
            } else if (eBottom > cBottom) {
                container.scrollTop += (eBottom - cBottom);
            }
        },
        revealText(numberString: string, event: Event, currentBackground?: string) {
            // Functionality to reveal next segment of text
            const elementToReveal = document.querySelector(`[data-segment="${numberString}"]`);
            (event.target as HTMLElement).classList.add('exhausted');

            if (elementToReveal && elementToReveal.classList.contains('hidden')) {
                elementToReveal.classList.remove('hidden');
                (this.simplebar as any).recalculate();

                setTimeout(() => {
                    elementToReveal.classList.add('revealed');

                    // TODO: Find a better way of doing this. Right now when a section is revealed,
                    // we just want to scroll to the bottom of the div so that it is visible.
                    this.ensureInView(this.simplebarScrollElement as any, elementToReveal as HTMLElement);
                }, 400);

                this.$store.commit('incrementCounter');

                if (currentBackground) {
                    this.$store.commit('changeBackground', currentBackground);
                }
            } else {
                console.warn('no element to reveal');
            }
        },
    },
    mounted() {
        this.$nextTick(() => {
            this.simplebar = new SimpleBar(this.$refs.simplebar);
            this.simplebarScrollElement = (this.simplebar as any).getContentElement();
        });
    },
});
